<template>
    <div class="match-view font-bold">
        <div class="row">
            <div class="table-first-column-mobile table-match-mobile">
                <div class="mobile-match-odd">
                    <div class="">
                        <span v-if="isLive" class="live-text animate-flicker">
                            <img class="live-logo live-logo-mobile" src="/live_logo.svg" alt="live">
                            {{translate('general', 'Live', language)}}
                        </span>
                        <span v-else-if="isToday"> {{ formatTime() }} {{ formatAmPm() }} </span>
                        <span v-else> {{ formatDate() }} {{ formatTime() }} {{ formatAmPm() }} </span>
                    </div>
                    <div class="team-names-column">
                        {{translate('teams', matchInfo.OddsData_HomeTeam, language)}}
                        <br>
                        {{translate('teams', matchInfo.OddsData_AwayTeam, language)}}
                        <br>
                        <button class="btn btn-link btn-all-odds font-bold">{{translate('general', 'All Odds', language)}}</button>
                    </div>
                </div>
            </div>
            <div class="match-view-odds div-scroll-hacked table-second-column-mobile">
                <div class="match-view-hack" :style="'width:'+hackedWidthWhenRow+'px'">
                    <div class="row" v-if="isVisible">
                        <div
                            v-for="market in availableMarketList"
                            class="match-view-block-market"
                            :class="(flickerMarket === market.name)? 'animate-column' : ''"
                            :key="'market_odd_'+market.name"
                        >
                          <component
                              :is="market.component"
                              :odds="getMarketOdds(market.name)"
                              :market="market.name"
                              :matchInfo="matchInfo"
                              :ref="'ref_odd_'+market.name"
                          />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */

const _ = require('lodash')
const moment = require('moment-timezone')
import FH_THDP from "./Markets/FH_THDP";
import FH_T1X2 from "./Markets/FH_T1X2";
import FH_TCS from "./Markets/FH_TCS";
import FGLG from "./Markets/FGLG";
import HTFT from "./Markets/HTFT";
import FH_TML from "./Markets/FH_TML";
import FH_TOE from "./Markets/FH_TOE";
import FH_TOU from "./Markets/FH_TOU";
import TG from "./Markets/TG";
import { mapGetters } from 'vuex'
    export default {
        name: 'MatchView',
        components: {
            TG,
            FH_TOU,
            FH_TOE,
            FH_TML,
            HTFT,
            FGLG,
            FH_TCS,
            FH_T1X2,
            FH_THDP,
        },
        computed: {
            ...mapGetters({
                hackedWidthWhenRow: 'counters/hackedWidthWhenRow',
                availableMarketList: 'counters/availableMarketList',
                isMobile: 'settings/isMobile',
                visibleLeagues: 'leagues/visibleLeagues',
                language: 'settings/language',
                flickerMarket: 'settings/flickerMarket',
            })
        },
        watch: {
            'visibleLeagues': function (){
                this.isVisible = this.visibleLeagues[this.leagueKey]
            }
        },
        props:{
            match:Object,
            matchId:Number,
            leagueKey:String,
            matchInfo: Object,
        },
        data() {
            return {
                isLive: '',
                isToday: '',
                isVisible: true,
                momentOriginalDate: null,
            }
        },
        methods:{
            formatDate() {
                return this.momentOriginalDate.format('MM/DD')
            },
            formatTime() {
                return this.momentOriginalDate.format('hh:mm')
            },
            formatAmPm() {
                return this.momentOriginalDate.format('A')
            },
            hasMarketOdds(market) {
                return Object.prototype.hasOwnProperty.call(this.match, market)
            },
            getMarketOdds(market) {
                if(this.hasMarketOdds(market)){
                    return _.clone(this.match[market])
                }
            }
        },
        created() {
            this.momentOriginalDate = moment(new Date(this.matchInfo.Date + '+08:00'))
            this.isLive = this.momentOriginalDate.isBefore(moment());
            this.isToday = this.momentOriginalDate.isBefore(moment());
        }
    }
</script>